import { Highlight } from '@curology/ui-components-web/react/Highlight';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { IngredientsAccordion } from '../IngredientsAccordion';
import { ModalImage } from '../ModalImage';
import { ModalPricingVolumeAndProductOptionSelector } from '../ModalPricingVolumeAndProductOptionSelector';

export const FutureFormulaModalContent = ({
  modalCard,
}: {
  modalCard: Card;
}) => {
  const { modal } = modalCard;

  return (
    <>
      <ModalImage modal={modal} />
      <Typography className="cur-mt-4" size="h2">
        {modal.title}
        <sup>Rx</sup>
      </Typography>
      <ModalPricingVolumeAndProductOptionSelector modalCard={modalCard} />
      {modalCard.recommendationText && (
        <Highlight className="cur-mt-4" state="success">
          <div
            dangerouslySetInnerHTML={{
              __html: modalCard.recommendationText.modalCallout,
            }}
          ></div>
        </Highlight>
      )}
      <Typography className="cur-mt-4">
        Your provider will review your answers and photos, and prescribe custom
        ingredients—at a custom strength—for your skin’s unique needs. But the
        personalization doesn’t stop there. Before each new shipment, we’ll
        check in to see how you’re doing—and recommend updates to your
        prescription to ensure it is always the right fit for your changing
        skin. Your Future Formula will be unscented and paraben-free.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        Active ingredients
      </Typography>
      <Typography className="cur-mt-4">
        Your provider will prescribe 4 of the following active ingredients to
        include in your Future Formula:
      </Typography>
      <IngredientsAccordion
        body="Gently exfoliates and reduces excess pigment to help smooth and brighten skin"
        title="Azelaic acid"
      />
      <IngredientsAccordion
        body="Helps smooth texture and fine lines while brightening skin"
        title="Tretinoin"
      />
      <IngredientsAccordion
        body="Fights free radicals, soothes inflammation and visibly fades dark spots"
        title="Niacinamide"
      />
      <IngredientsAccordion
        body="Attracts and holds moisture for softer, smoother skin"
        title="Dexpanthenol"
      />
      <IngredientsAccordion
        body="Helps lighten dark spots and reduce redness"
        title="Tranexamic acid"
      />
      <Typography className="cur-mt-4" size="h3">
        Inactive ingredients
      </Typography>
      <Typography className="cur-mt-4">
        Aloe Barbadensis Leaf Juice, C13-14 Isoparaffin, Caprylic/Capric
        Triglyceride, Deionized Water, Laureth-7, Phenoxyethanol,
        Polyacrylamide, Tocopheryl Acetate, Triethylene Glycol
      </Typography>
      <Typography className="cur-mt-4">
        All formulas containing dexpanthenol or both niacinamide and azelaic
        acid also contain propylene glycol.
      </Typography>
    </>
  );
};
